import { render } from "./VirtualApisTable.vue?vue&type=template&id=224fea85"
import script from "./VirtualApisTable.vue?vue&type=script&lang=js"
export * from "./VirtualApisTable.vue?vue&type=script&lang=js"

import "./VirtualApisTable.vue?vue&type=style&index=0&id=224fea85&lang=sass"
import "./VirtualApisTable.vue?vue&type=style&index=1&id=224fea85&lang=sass"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QIcon,QTooltip,QSpinnerGears,QTable,QTr,QTd,QBtn});
